export default {
  onlineStatus: null,
  products: [],
  productBadges: [],
  allAttributes: [],
  debugMsg: '',
  emptyObject: {
    productCode: '',
    productCodeAttributes: [],
    productCodeId: null,
    productStock: 0,
    productActive: false
  },
  config: {
    showInactiveProductCodes: false
  },
  cart: {
    cartContents: [],
    giftContents: [],
    giftRules: [],
    cartErrors: []
  },
  emptyProduct: {
    productId: '',
    productUrl: '',
    productName: '',
    images: {
      0: [{
        is_main: '1',
        original: '/files/products/no_photo.jpg',
        small: '/files/products/no_photo.jpg',
        medium: '/files/products/no_photo.jpg',
        large: '/files/products/no_photo.jpg'
      }]
    },
    productImage: 'no-image.jpg',
    productBadge: '0',
    productWeight: '0',
    productDescription: '',
    productPoints: 0,
    productHasDiscount: false,
    productDisclosure: '',
    productOldPrice: '00',
    productFinalPrice: '0',
    productStock: 0,
    barCodes: [''],
    productCodes: [
      {
        productCode: '',
        productStock: 1,
        productCodeId: null,
        productActive: false,
        productCodeAttributes: []
      }
    ],
    vendorName: '',
    vendorLogo: 'no-image.jpg',
    vCCSign: '&euro;',
    noImage: '/ui/front/img/no_photo.jpg'
  },
  productCardModal: {
    open: false,
    productId: null
  },
  noImage: '/ui/main/img/no_photo.jpg',
  selectedProductCodeId: null,
  selectedAttributeId: null,
  selectedGifts: {}
}
